<template>
  <div v-if="game" class="game-play-page page-container">
    <div class="play-header"><span>{{ game.name }}</span><el-button type="text" icon="el-icon-close" @click="closePage">关闭游戏</el-button></div>
    <component :is="game.component" class="play-stage" />
  </div>
</template>

<script>
import { findGame } from '../config/games'

export default {
  name: 'GamePlayPage',
  data() {
    return { game: null }
  },
  created() {
    this.game = findGame(this.$route.params.id)
    // 非法游戏地址直接回列表，避免空白页。
    if (!this.game) this.$router.replace('/games')
  },
  methods: {
    closePage() {
      // 本页由 window.open 打开，可直接关闭；兜底跳回列表。
      window.close()
      this.$router.push('/games')
    }
  }
}
</script>

<style scoped>
.game-play-page { padding: 0 24px 24px; }
.play-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 16px 4px;
  border-bottom: 1px solid var(--line-soft);
  color: var(--ink);
  font-size: 16px;
  font-weight: 600;
}
.play-stage { border-radius: var(--r-lg); }
@media (max-width: 650px) { .game-play-page { padding: 0 12px 12px; } }
</style>
